<template>
  <div class="container">
    <div class="rate-main">
      <div class="rate-box">
        <div class="rate-cell flex-rsc">
          <span class="tit">总体评分</span>
          <van-rate
            v-model="totalScore"
            allow-half
            void-icon="star"
            gutter="9"
            size="24"
          ></van-rate>
        </div>
        <div class="rate-cell flex-rsc">
          <span class="tit">技师评分</span>
          <van-rate
            v-model="mechScore"
            allow-half
            void-icon="star"
            gutter="9"
            size="24"
          ></van-rate>
        </div>
        <div class="rate-cell flex-rsc">
          <span class="tit">环境评分</span>
          <van-rate
            v-model="envScore"
            allow-half
            void-icon="star"
            gutter="9"
            size="24"
          ></van-rate>
        </div>
      </div>
      <div class="opinion-box">
        <h3>请留下您宝贵的意见</h3>
        <van-cell-group class="field-box">
          <van-field
            v-model="content"
            rows="5"
            autosize
            type="textarea"
            maxlength="200"
            placeholder="请输入留言"
            show-word-limit
          ></van-field>
        </van-cell-group>
        <div class="msg">
          最少5字，最多200字
        </div>
      </div>
      <div class="button-default " :class="isApp === 'isWeixin' ? 'wx-button-primary' : 'zfb-button-primary'" @click="comment">
        提交
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Rate } from "vant";
import { Dialog } from 'vant';
export default {
  name: "comment",
  data() {
    return {
      totalScore: 0, // 总体评分
      mechScore: 0, // 技师评分
      envScore: 0, // 环境评分
      content: "",
      orderNo: ''
    }
  },
  computed: {
    ...mapState(['isApp'])
  },
  components: {
    [Rate.name]: Rate,
    [Dialog.name]: Dialog
  },
  mounted () {
    const { orderNo = '' } = this.$route.query
    this.orderNo = orderNo
  },
  methods: {
    comment () {
      const { totalScore, mechScore, envScore, content, orderNo } = this
      if (!content) return this.$toast('请留下您宝贵的意见,最少五个字！')
      if (content && content.length < 5) return this.$toast('请留下您宝贵的意见,最少五个字！')
      this.$api.pay.commentApi({
        totalScore,
        mechScore,
        envScore,
        content,
        bizNo: orderNo
      }).then(res => {
        console.log(res);
        if (res.errCode === '0') {
          let content = '优惠劵已放到你的账户，你可打开小程序查看。'
          const {tip = '', giveFlag = false, isGive = false} = res.data
          if (isGive && giveFlag) {
            content = tip
          }
          Dialog.alert({
            title: '评价成功',
            message: content
          }).then(() => {
            // on close
            this.goHome()
          });
        } else {
          this.$toast(res.errMsg)
        }
      });
    },
    goHome () {
      this.$router.replace({ path: '/pay' })
    },
    // onClickLeft() {
    //   this.$router.go(-1);
    // }
    // goRouter() {
    //   this.$router.push({ path: "/commentSuccess" });
    // }
  }
};
</script>

<style scoped lang="stylus">
@import '../../assets/stylus/mixins.styl'
.container
  min-height 100vh
  background-size cover
  .rate-main
    padding 20px 40px
    .rate-box
      padding 16px
      background rgba(255,255,255,1)
      border 2px solid rgba(183, 207, 255, 1)
      border-radius 6px
      .rate-cell
        padding 6px 0
        .tit
          margin-right 8px
          font-size 16px
          font-weight bold
    .opinion-box
        margin-top 40px
        .field-box
          border 2px solid #B7CFFF
          border-radius 6px
          overflow hidden
        .msg
            text-align right
            font-size 12px
            line-height 3em
            color #828282
    .button-default
        width 60vw
        margin 20px auto
</style>
